import { OPT_OUT_COOKIE_NAME } from '@lib/constants/oneTrust';
import { getFunctionalConsentStatus } from '@lib/cookieConsent/cookieConsent';
import Cookie from 'js-cookie';

/**
 * localStorage key of the per-browser Coveo client id. The header search
 * engine owns it — persisting it only with functional consent — and search
 * telemetry reads it as its pseudonymous session key.
 */
export const CLIENT_ID_STORAGE_KEY = 'coveo_client_id';

/**
 * Read consent straight from the OneTrust cookie rather than through
 * useCookieSettings: callers run outside React (engine build, Redux
 * middleware), and the hook's initial state is false until an effect reads the
 * same cookie. Reading it on every call also sees a change OneTrust made
 * mid-visit. A malformed cookie value makes decodeURIComponent throw; no
 * consent is the safe reading of one.
 */
export function hasFunctionalConsent(): boolean {
  try {
    return getFunctionalConsentStatus(
      decodeURIComponent(Cookie.get(OPT_OUT_COOKIE_NAME) || '')
    );
  } catch {
    return false;
  }
}
